import React, { useContext, useEffect, useState } from "react";
import Container from "./PvinContainer";
import { FilterContext } from "../../context/Filter";

// Simple loader
const Loader = () => (
  <div className="text-center py-4 text-gray-600 animate-pulse">
    Loading offer summary...
  </div>
);

const OfferSummary = ({ data }) => {
  const [showLoader, setShowLoader] = useState(false);
  const { open } = useContext(FilterContext); // ✅ move inside function body

  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    // Mark data as loaded even if it's empty
    if (data !== undefined) {
      setHasLoaded(true);
    }

    // If valid array data exists, show loader briefly
    if (Array.isArray(data) && data.length > 0) {
      setShowLoader(true);
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 800);

      return () => clearTimeout(timeout);
    }
  }, [data]);

  // Case: Initial loading – render nothing
  if (!hasLoaded) return null;

  // Case: Data has loaded, but is empty or invalid
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Offer Summary</h2>
        <div className="text-sm text-red-600">
          No subscription data available.
        </div>
      </Container>
    );
  }

  // Case: Data exists but still showing loader
  if (showLoader) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Offer Summary</h2>
        <Loader />
      </Container>
    );
  }

  // Case: Render actual data
  return (
    <Container>
      {/* TATA Care Coupon */}
      <div className="w-full">
        <h2 className="text-xl font-semibold">TATA Care Coupon</h2>
        <table className=" w-full text-sm font-semibold border-collapse">
          <thead>
            <tr className="bg-[#056db3] text-white">
              <th className="px-4 py-2 border">Total</th>
              <th className="px-4 py-2 border">Used</th>
              <th className="px-4 py-2 border">Balance</th>
              <th className="px-4 py-2 border">Expired</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-blue-700">
              <td className="px-4 py-2 border text-center">
                {data[0]?.Earned_Total_Points ?? "0"}
              </td>
              <td className="px-4 py-2 border text-center">
                {data[0]?.Earned_Used_Points ?? "0"}
              </td>
              <td className="px-4 py-2 border text-center">
                {data[0]?.Earned_Balance_Points ?? "0"}
              </td>
              <td className="px-4 py-2 border text-center">
                {data[0]?.Earned_Expired_Points ?? "0"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Loyalty Points */}
      <div>
        <h2 className="text-xl font-semibold mt-4">Loyalty Points</h2>
        <table className="table-auto w-full text-sm font-semibold border-collapse">
          <thead>
            <tr className="bg-[#056db3] text-white">
              <th className="px-4 py-2 border">Total</th>
              <th className="px-4 py-2 border">Used</th>
              <th className="px-4 py-2 border">Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-4 py-2 border text-center">
                {data[1]?.Delight_Total_Points ?? "0"}
              </td>
              <td className="px-4 py-2 border text-center">
                {data[1]?.Delight_Used_Points?.toFixed(2) ?? "0.00"}
              </td>
              <td className="px-4 py-2 border text-center">
                {data[1]?.Delight_Balance_Points?.toFixed(2) ?? "0.00"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default OfferSummary;
